import CONTENT_HEADER from '../plugins/content_header'
const [w,l] = [window,location]

export default function INTRODUCTION() {

  // GOOGLEMAP() // Googlemap実行パート
  
  CONTENT_HEADER();
  $(() => {
    w.load['CONTENT_HEADER'].done(() => {
      const id = l.search ? l.search.match(/article=(\d+)/)[1] : '1'
      const renameHeader = (title) => $('.mainImg .mainImgInner h2 span').html(title)
      if(id == 2){
        renameHeader('園の概要');
      }
    })
  })
}